import { createNamespacedHelpers, Module } from "vuex";
import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import {
  WatercraftTypeState,
  WatercraftTypeGetters,
  WatercraftTypeMutations,
  WatercraftTypeActions
} from "./types";

const namespaced = true;
export const namespace = "watercraftType";

export const {
  mapState: watercraftTypeMapState,
  mapGetters: watercraftTypeMapGetters,
  mapMutations: watercraftTypeMapMutations,
  mapActions: watercraftTypeMapActions
} = createNamespacedHelpers<
  WatercraftTypeState,
  WatercraftTypeGetters,
  WatercraftTypeMutations,
  WatercraftTypeActions
>(namespace);

export const watercraftType: Module<WatercraftTypeState, any> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
